import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonSubscribe from '@common/react/components/UI/Subscribe/Subscribe';

import { useReduxContext } from '@app/hooks/useReduxContext';
import TranslatedFormikField from '@app/components/Forms/TranslatedFormikField/TranslatedFormikField';

import '@app/scss/subscribe.scss';

interface Props {
	description?: string;
	title?: string;
	className?: string;
}

const Subscribe: React.FC<Props> = (props) => {
	const {
		companySettings,
	} = useReduxContext();
	const { t } = useTranslation();
	const {
		description,
		title = t('forms.Subscribe to our newsletter'),
		className = '',
	} = props;

	if (!companySettings.subscribe) {
		return <></>;
	}

	return <div className="container">
		<CommonSubscribe
			title={title}
			description={description}
			className={className}
			namePlaceholder={t('forms.name')}
			text={{
				subscribe: t('forms.Subscribe'),
				close: t('forms.Close'),
				requestSuccess: t('forms.subscribeSuccess'),
			}}
			getErrorMessage={(error) => (error === 'You have already subscribed'
				? t(error)
				: <>
					Oops!!!
					<br />
					{t('Something went wrong')}
				</>)}
			formikField={TranslatedFormikField}
		/>
	</div>;
};

export default Subscribe;
